import { render, staticRenderFns } from "./InheritLogDialog.vue?vue&type=template&id=dad331a6&scoped=true&"
import script from "./InheritLogDialog.vue?vue&type=script&lang=js&"
export * from "./InheritLogDialog.vue?vue&type=script&lang=js&"
import style0 from "./InheritLogDialog.vue?vue&type=style&index=0&id=dad331a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad331a6",
  null
  
)

export default component.exports